import {useEffect, useState} from 'react';
import {useNavigate, useParams} from 'react-router-dom';
import axios from 'axios';
import config from '../../config/config';
import styles from './SubServicesPage.module.scss';

function SubServicesPage() {
    const {group} = useParams();
    const navigate = useNavigate();
    const [services, setServices] = useState<any[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const decodedGroup = decodeURIComponent(group || '');

        axios
            .get(`${config.url_provet_api}mysklad/services`)
            .then((response) => {
                const foundCategory = response.data.response.find((cat: any) => cat.name === decodedGroup);

                if (foundCategory) {
                    setServices(foundCategory.services);
                } else {
                    setError('Подкатегория не найдена');
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setError('Ошибка при загрузке данных');
                setIsLoading(false);
                console.error(err);
            });
    }, [group]);

    if (isLoading) {
        return (
            <div className={styles.section}>
                <div className={styles.inSection}>
                    <div className={styles.loadingContainer}>
                        <div className={styles.spinner}></div>
                        <p className={styles.loadingText}>Загрузка услуг...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className={styles.section}>
                <div className={styles.inSection}>
                    <div className={styles.errorContainer}>
                        <h2 className={styles.errorTitle}>Ошибка</h2>
                        <p className={styles.errorText}>{error}</p>
                        <button
                            className={styles.backButton}
                            onClick={() => navigate('/services')}
                        >
                            Вернуться к списку услуг
                        </button>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <section className={styles.section}>
            <div className={styles.inSection}>
                <div className={styles.container}>
                    <button
                        className={styles.backButtonHeader}
                        onClick={() => navigate('/services')}
                    >
                        <span className={styles.backArrow}>←</span>
                        Назад к услугам
                    </button>

                    <div className={styles.categoryHeader}>
                        <h1 className={styles.categoryTitle}>
                            {decodeURIComponent(group || '')}
                        </h1>
                        <p className={styles.servicesCount}>
                            {services.length} {services.length === 1 ? 'услуга' :
                            services.length > 1 && services.length < 5 ? 'услуги' : 'услуг'}
                        </p>
                    </div>

                    <div className={styles.servicesRow}>
                        {services.map((service, index) => (
                            <div key={index} className={styles.serviceCard}>
                                <div className={styles.serviceHeader}>
                                    <h3 className={styles.serviceName}>{service.name}</h3>
                                    <div className={styles.priceContainer}>
                                        <span className={styles.price}>{service.price} ₽</span>
                                    </div>
                                </div>

                                {service.description && (
                                    <p className={styles.serviceDescription}>{service.description}</p>
                                )}

                                <div className={styles.serviceFooter}>
                                    <span className={styles.serviceNumber}>#{index + 1}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}

export default SubServicesPage;